import { Address } from "@apis/index";
import { RootState } from "@store/index";
import React, { useCallback, useEffect } from "react";
import { useSelector } from "react-redux";

const useAddressess = ({
  provinceName,
  districtName,
}: {
  provinceName?: string;
  districtName?: string;
}) => {
  console.log({ districtName });
  const { data: provinces } = useSelector(
    (state: RootState) => state.provinces,
  );
  const { data: districts } = useSelector(
    (state: RootState) => state.districts,
  );
  const { data: municipals } = useSelector(
    (state: RootState) => state.municipals,
  );
  console.log({ municipals });
  const getProvinces = useCallback(async () => {
    await Address.getProvinces({ state: "provinces" });
  }, []);
  const getDistrictsByProvince = useCallback(async () => {
    await Address.getDistrictsByProvince({
      state: "districts",
      params: { province: provinceName },
    });
  }, [provinceName]);

  const getMunicipalitiesByDistrict = useCallback(async () => {
    await Address.getMunicipalitiesByDistrict({
      state: "municipals",
      params: { district: districtName },
    });
  }, [districtName]);
  useEffect(() => {
    getProvinces();
    if (provinceName) {
      getDistrictsByProvince();
    }
    if ( districtName) {
      getMunicipalitiesByDistrict();
    }
  }, [
    getProvinces,
    getDistrictsByProvince,
    getMunicipalitiesByDistrict,
    provinceName,
    districtName,
  ]);
  return {
    provinces,
    districts,
    municipals,
    getProvinces,
    getDistrictsByProvince,
    getMunicipalitiesByDistrict,
  };
};

export default useAddressess;
